// <s-reveal> — marks itself data-inview the first time it scrolls into view, so CSS can
// transition its children in. Reduced-motion visitors get the final state immediately.
class SReveal extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
      this.dataset.inview = "";
      return;
    }

    const threshold = parseFloat(this.dataset.threshold) || 0.2;
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.dataset.inview = "";
          this.#observer?.disconnect();
        }
      },
      { threshold, rootMargin: "0px 0px -8% 0px" },
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get("s-reveal")) customElements.define("s-reveal", SReveal);
